import { type MetadataFieldWithValue } from '@/model/Metadata.model';
import { type components } from '@/generated/internal-api/openapi-types';
import { type ID } from '@/model/Common.model';
import { type StrainApiId } from '@/model/Strain.model';
import { type TempAnimalApiId, type TempAnimalDefinitionApiId } from '@/model/SamplePlan.model';

export type AnimalDefinitionApiId = components['schemas']['AnimalDefinitionApiId'];

export interface PlannedAnimal {
  temp_id: TempAnimalApiId | TempAnimalDefinitionApiId;
  name: string;
  group_temp_id?: string;
  sex: string;
  dob?: string;
  species?: string;
  strain?: string;
  strainApiId?: StrainApiId;
  metadata?: Record<ID, MetadataFieldWithValue>;
}

export type PlannedAnimalData =
  | { type: 'planned'; animals: Array<PlannedAnimal> }
  | {
      type: 'registered';
      animalsPerCage: number;
      animals: Array<PlannedAnimal>;
    }
  | { type: 'skip' };

export type PlanTypes = PlannedAnimalData['type'];

export const PlanTypeMap = {
  planned: 'planned',
  registered: 'registered',
  skip: 'skip',
} as const;

export type AnimalDefinitionUpsertV1 = components['schemas']['AnimalDefinitionUpsertV1'];
export type AnimalCreateFromDefinitionV1 = components['schemas']['AnimalCreateFromDefinitionV1'][];
export type AnimalDefinitionMappingV1 = components['schemas']['AnimalDefinitionMappingV1'];
export type AnimalCreateV1 = components['schemas']['AnimalCreateV1'];
export type AnimalMapV1 = components['schemas']['AnimalMapV1'];
export type AnimalDefinitionTargetAnimal = components['schemas']['AnimalDefinitionTargetAnimalV1'];
